import { useContext } from 'react'

import PageWrapper from '/components/page-wrapper'

import HelpText from '/help/dashboard'
import Templates from '/components/dashboard/templates'
import Statistics from '/components/dashboard/statistics'
import Billing from '/components/dashboard/billing'
import AccountManagement from '/components/dashboard/account-management'
import ActivePasses from '/components/dashboard/active-passes'
import CreateTemplate from '/components/dashboard/new-template'
import Support from '/components/dashboard/support'
import Apps from '/components/dashboard/download-apps'

import { AppContext } from '/providers/app-context'

const Dashboard = () => {

  const { user } = useContext(AppContext)

  return (
    <PageWrapper title="Dashboard" HelpText={HelpText} heading="Smartix Studio Dashboard">
      <div className='flex flex-wrap gap-5 overflow-auto p-10 justify-center h-full content-start dashboard max-w-[1300px] m-auto'>
        <Templates />
        <CreateTemplate />
        <ActivePasses />
        {user?.permissions.client_admin &&
          <>
            <Statistics />
            <Billing />
          </>
        }
        <AccountManagement />
        <Apps />
        <Support />
      </div>
    </PageWrapper>
  )
}

export default Dashboard